
import Vue from 'vue';
import Component from "vue-class-component";
import { Tr } from "@/i18n/i18n";
import PlayerStore from "@/store/player";
import { Prop } from 'vue-property-decorator';
import { Settings } from '@/constants/settings';
import {IntegrationUtils} from "@/utils/integration-utils";

@Component
export default class MessageOptions extends Vue {
      get trAnswer() { return Tr('answer'); }
      get trDelete() { return Tr('delete.message'); }
      get trCopy() { return Tr('copy.msg'); }
      get trEdit() { return Tr('edit'); }
      get trBlock() { return Tr('block'); }

      private readonly forwardedMessagePrefix = Settings.FORWARDED_MESSAGE_PREFIX;
      @Prop({ default: 1 }) private accessLevel!: number;
      @Prop() private roomId!: string;

      get numberOfElements() {
            // @ts-ignore
            return this.$refs.body.querySelectorAll(':not([style*="display: none"])').length;
      }

      get canDeleteMassage() {
            // @ts-ignore
            return this.$parent.isModerator && this.roomId !== Settings.PRIVAT_CHAT_ROOM;
      }

      get canAnswer() {
            // @ts-ignore
            return !this.$parent.isSmileyClass;
      }

      get isSmiley() {
            // @ts-ignore
            return this.$parent.isSmileyClass ? 'isSmiley' : '';
      }

      private answer(): void {
            this.$emit("answerCallback")
            this.setDisable();
      }

      private copy(): void {
            // @ts-ignore
            let messageText = this.$parent.messageText;
            
            if (messageText.includes(this.forwardedMessagePrefix)) {
                  const splitMessege = messageText.split(this.forwardedMessagePrefix);
                  messageText = splitMessege[splitMessege.length - 1];
            }

            IntegrationUtils.copyToClipboard(messageText);
            this.setDisable();
      }

      private edit(): void {
            console.log("edit");
      }

      private deleteMassage(): void {
            this.$emit("deleteCallback")
            this.setDisable();
      }

      private block(): void {
            console.log("block");
      }

      public setVisible(offsetX: number, offsetY: number) {
            const messageOptionsIsAvailable = PlayerStore.getPlayer()!.level >= this.accessLevel;
            
            if (messageOptionsIsAvailable && this.numberOfElements > 0) {

                  // @ts-ignore
                  this.$refs.wrapper.classList.add('open');
                  // @ts-ignore
                  this.$refs.wrapper.style.left = offsetX + 'px';
                  // @ts-ignore
                  this.$refs.wrapper.style.top = offsetY + 'px';
                  // @ts-ignore
                  this.$refs.wrapper.style.marginTop = -8 - (6 * (this.numberOfElements - 1)) + 'vh';
            }
      }

      public setDisable() {
            // @ts-ignore
            this.$refs.wrapper.classList.remove('open');
      }
}
